import { isGuest } from "@utils/permissions";
import { Project, ProjectTheme, User } from "types";

export function getVisibleThemesFromProject(
  project?: Project,
  userData?: User | null,
): ProjectTheme[] {
  if (!project) return [];
  // filter out each controlpoint that is hidden if the user is a GUEST
  const themes = project.themes.map((theme) => {
    const visibleSteps = theme.steps.filter((step) => {
      if (step.controlpoints)
        step.controlpoints = step.controlpoints.filter((cp) => {
          if (isGuest(userData) && cp.hidden) {
            return false;
          }
          return true;
        });
      return true;
    });
    return {
      ...theme,
      steps: visibleSteps,
    };
  });
  return themes;
}
